import { msg } from 'api';
import { catalogueStaticLinks } from 'apps/catalogue/links';

export function buildPromosLinks() {
  const { labels } = msg.nav;

  return [
    { name: 'New', type: 'new', link: catalogueStaticLinks.NEW },
    { name: labels.allOffers, type: 'other', link: catalogueStaticLinks.OFFERS },
    { name: labels.mealDeals, type: 'other', link: '/webshop/displayBundles.do?mealDealBundles=true' }, // TODO should be /meal-deals
    { name: labels.bundleOffers, type: 'other', link: '/webshop/displayBundles.do' }, // TODO should be /bundle-offers
  ];
}
